import "./CrudTable.css"

function CrudTable({
  columns,
  data,
  onEdit,
  onDelete,
  actionsLabel = "Actions",
  editLabel = "Edit",
  deleteLabel = "Delete",
}) {
  return (
    <table className="table crud-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key}>{col.label}</th>
          ))}
          <th>{actionsLabel}</th>
        </tr>
      </thead>

      <tbody>
        {data.map((item) => (
          <tr key={item.id}>
            {columns.map((col) => (
              <td key={col.key}>
                {typeof col.render === "function"
                  ? col.render(item)
                  : item[col.key]}
              </td>
            ))}

            <td>
              <button
                className="btn btn-sm btn-warning me-2"
                onClick={() => onEdit(item)}
              >
                {editLabel}
              </button>

              <button
                className="btn btn-sm btn-danger"
                onClick={() => onDelete(item.id)}
              >
                {deleteLabel}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CrudTable;